/* eslint-disable no-unused-vars */
const apiUrl = 'http://15.164.224.135'

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = {
    apiUrl: apiUrl
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/settings-local.js
// module id = 8FGW
// module chunks = 1